export default __webpack_public_path__ + "static/media/print.e86c66b4.svg";